
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-purple-900 rounded-t-[40px] mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            {/* Logo e tagline removidos */}
          </div>

          <div>
            <h3 className="text-white text-lg font-bold mb-6">Navegação</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-white/80 text-sm hover:text-gold-400 transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <a href="/#programa" className="text-white/80 text-sm hover:text-gold-400 transition-colors">
                  O Programa
                </a>
              </li>
              <li>
                <Link to="/modulos" className="text-white/80 text-sm hover:text-gold-400 transition-colors">
                  Módulos
                </Link>
              </li>
              <li>
                <a href="/#especialistas" className="text-white/80 text-sm hover:text-gold-400 transition-colors">
                  Especialistas
                </a>
              </li>
              <li>
                <Link to="/investimento" className="text-white/80 text-sm hover:text-gold-400 transition-colors">
                  Investimento
                </Link>
              </li>
              <li>
                <Link to="/inscricao" className="text-white/80 text-sm hover:text-gold-400 transition-colors">
                  Inscrição
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-lg font-bold mb-6">Fale Conosco</h3>
            <ul className="space-y-5">
              <li className="flex items-center space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-gold-400 text-xl"></i>
                </div>
                <a href="https://wa.me/5521971784539" className="text-white text-sm hover:text-gold-400 transition-colors">
                  (21) 97178-4539
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-mail-line text-gold-400 text-xl"></i>
                </div>
                <a href="mailto:amaisbusinessinstitute@gmail.com" className="text-white text-sm hover:text-gold-400 transition-colors">
                  amaisbusinessinstitute@gmail.com
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-instagram-line text-gold-400 text-xl"></i>
                </div>
                <a href="https://instagram.com/programasaltoalto" target="_blank" rel="nofollow noopener noreferrer" className="text-white text-sm hover:text-gold-400 transition-colors">
                  @programasaltoalto
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-lg font-bold mb-6">Receba novidades</h3>
            <p className="text-white/70 text-sm mb-4">
              Inscreva-se para receber conteúdos exclusivos sobre liderança feminina
            </p>
            <form className="relative" data-readdy-form id="newsletter-form">
              <input
                type="email"
                name="email"
                placeholder="Seu e-mail"
                required
                className="w-full bg-purple-800 border border-white/30 rounded-xl h-13 px-4 text-white text-sm placeholder:text-white/50 focus:outline-none focus:border-gold-400"
              />
              <button
                type="submit"
                className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 bg-gold-500 rounded-full flex items-center justify-center hover:bg-gold-400 transition-colors"
              >
                <i className="ri-arrow-right-line text-white"></i>
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/20 mt-16 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/60 text-sm text-center md:text-left">
              © 2025 Eu Lidero. Todos os direitos reservados.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/60 text-sm hover:text-gold-400 transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-purple-800 text-[180px] font-bold opacity-10 pointer-events-none select-none whitespace-nowrap">
        EU LIDERO
      </div>
    </footer>
  );
}
